import { FAILSAFE_DELAY_MS, LOADING_SCREEN_SELECTOR } from './showDelay';

// `inert` takes covered content out of the tab order and the accessibility tree. Where it is
// unsupported, aria-hidden hides the content from assistive tech; CoveredContent's focus guard
// backs up both, as the wrapper is `display: contents` and engines have handled that box
// inconsistently.
export const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;

export const setContentCovered = (element, covered) => {
  if (covered) {
    element.setAttribute('inert', '');
    if (!supportsInert()) element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('inert');
    element.removeAttribute('aria-hidden');
  }
};

// Inline script rendered as the first child of server-rendered covered content: it makes the
// content inert before any of it is parsed, so nothing behind the cover can be focused even
// before the app's script arrives. Without script the cover is hidden (by a <noscript> style)
// and this never runs, so the content is never left inert. If the app's script never takes
// over, the cover's CSS failsafe reveals the page; its animation is the only one on the cover
// element itself, so its start releases the content too, and when parsing stalled long enough
// for it to have started already the content is left alone. Once the app takes over it
// cancels that animation and releases the content itself (see CoveredContent).
// Whether the failsafe has started is decided as hasServerFailsafeStarted decides it, so the
// content and the cover (LoadingScreen) never disagree about whether the page was revealed.
export const buildCoverInertScript = () => `(function(){try{
var content=document.currentScript&&document.currentScript.parentNode;
var cover=document.querySelector(${JSON.stringify(LOADING_SCREEN_SELECTOR)});
if(!content||!cover)return;
var animations=cover.getAnimations?cover.getAnimations():[];
var failsafe=animations[animations.length-1];
if(failsafe?failsafe.playState==='finished'||failsafe.currentTime>=${FAILSAFE_DELAY_MS}:performance.now()>=${FAILSAFE_DELAY_MS})return;
content.setAttribute('inert','');
if(!('inert' in HTMLElement.prototype))content.setAttribute('aria-hidden','true');
function release(event){
if(event.target!==cover)return;
content.removeAttribute('inert');
content.removeAttribute('aria-hidden');
cover.removeEventListener('animationstart',release);
}
cover.addEventListener('animationstart',release);
}catch(e){}})();`;
